module.exports = __webpack_public_path__ + "static/media/execute_answer_comp_time.8bd2ebbe.png";